import React from "react";

const CheckBoxWithOutLabel = ({
  id,
  name,
  value = "",
  onChange,
  error,
  checked,
  readOnly = false,
  onClick,
  disabled = false,
}) => {
  return (
    <div className="flex flex-row justify-center">
      <input
        type="checkbox"
        className="w-6 h-6 p-0 m-0 accent-[#AB3C1B] disabled:bg-slate-200"
        name={`${name}`}
        id={`${id}`}
        value={value}
        checked={checked ? true : false}
        onChange={onClick}
        disabled={disabled}
      />
      <div className="h-2">
        <label
          htmlFor={id}
          className="font-normal text-[0.75rem] text-red-500 bg-white  pt-1 my-0 py-0 font"
        >
          {error}
        </label>
      </div>
    </div>
  );
};

export default CheckBoxWithOutLabel;
